<template>
  <div class="app-main">
    <HeaderA  @fatherMethod="fatherMethod" ></HeaderA>
    <div class="index">
      <div class="banner_carousel swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img :src="this.$store.state.serverImages.homeBannerImages1" alt="" />
          </div>
          <div class="swiper-slide">
            <img :src="this.$store.state.serverImages.homeBannerImages2" alt="" />
          </div>
          <div class="swiper-slide">
            <img :src="this.$store.state.serverImages.homeBannerImages3" alt="" />
          </div>
          <div class="swiper-slide">
            <img :src="this.$store.state.serverImages.homeBannerImages4" alt="" />
          </div>
        </div>
        <div class="swiper-button-prev swiper-button-white"></div>
        <div class="swiper-button-next swiper-button-white"></div>
        <!-- 如果需要分页器 -->
        <!-- <div class="swiper-pagination"></div> -->
        <div class="headline">
          <span class="headline_logo">头条</span>
          <div class="headline_title">
            <p>
              <marquee behavior="scroll" onmouseout="this.start()" onmouseover="this.stop()">
                <a @click="imgclickHander(item, 1)" :key="index" v-for="(item, index) in noticeData">▶{{ item.title }}</a>
              </marquee>
            </p>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content_top">
          <div class="content_desc">
            <h1>
              <router-link to="/stepInWetland/wetlandDescription">湿地简介</router-link>
            </h1>
            <p>Weatland introduction</p>
            <!-- <div>
							<img src="../assets/images/首页下箭头.png"/>
						</div> -->
            <div class="intro">
              <div class="content_video vanwee">
                <div class="video_hide" title="单击开始播放视频">
                  <img class="video_pause" src="../assets/images/继续播放.png" alt="" />
                </div>
                <video id="movie1" :src="this.$store.state.serverImages.videoUrl" controls="controls">
                  <!--正常视频链接-->
                  <source :src="this.$store.state.serverImages.videoUrl" type="video/mp4" />
                  抱歉，此浏览器不支持视频播放标签！
                </video>
              </div>
              <div class="video_intro">
                <span v-html="$store.state.serverImages.videoText"></span>
              </div>
            </div>
          </div>
          <div class="content_scenery">
            <h1>
              湿地风光
            </h1>
            <p>Weatland scenery</p>

            <div class="landscape_img_content vanwee">
              <div class="landscape_img_left">
                <div :key="index" v-for="(item, index) in wetlandSceneryData1">
                  <img :src="item.img" alt="" />
                  <div class="landscape_intro">
                    <p>{{ item.name }}</p>
                    <span v-html="item.content"></span>
                  </div>
                </div>
              </div>
              <div class="landscape_img_right">
                <div :key="index" v-for="(item, index) in wetlandSceneryData2">
                  <img :src="item.img" alt="" />
                  <div class="landscape_intro">
                    <p>{{ item.name }}</p>
                    <span v-html="item.content"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content_resources">
            <h1>
             湿地资源
            </h1>
            <p>Weatland resources</p>
            <div class="resources_box">
              <div class="resources_container">
                <a class="vanwee2" @click="
                    resourcesClick(
                      '/stepInWetland/index/AnimalResource',
                      'AnimalResource'
                    )
                  "><img :src="this.$store.state.serverImages.homeResourcesImages1" />
                  <span>动物资源</span>
                </a>
                <a class="vanwee2" @click="
                    resourcesClick(
                      '/stepInWetland/index/PlantResource',
                      'PlantResource'
                    )
                  "><img :src="this.$store.state.serverImages.homeResourcesImages2" />
                  <span>植物资源</span></a>
                <a class="vanwee2" @click="
                    resourcesClick(
                      '/stepInWetland/index/TourismResource',
                      'TourismResource'
                    )
                  "><img :src="this.$store.state.serverImages.homeResourcesImages3" />
                  <span>旅游资源</span></a>
              </div>
            </div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="popularization">
            <h1>
                湿地科普
            </h1>
            <p>Weatland science popularization</p>
            <div class="popularization_content">
              <!-- <div class="popularization_content_classroom">
                <div class="img">
                  <img
                    class="vanwee3"
                    :src="
                      this.$store.state.serverImages.homePopularScienceImages[0]
                    "
                  />
                </div>
                <div class="text vanwee3">
                  <p v-html="populariTitleItem[0]"></p>
                  <span v-html="populariDescItem[0]"></span>
                  <div
                    @click="
                      resourcesClick(
                        '/popularScience/index/PopularScience4',
                        'PopularScience4'
                      )
                    "
                  >
                    查看更多
                    <svg-icon class-name="search-icon" icon-class="右箭头" />
                  </div>
                </div>
              </div> -->
              <div class="popularization_content_propaganda" style="min-height:272px !important">
                <div class="img">
                  <img class="vanwee3" :src="
                      this.$store.state.serverImages.homePopularScienceImages
                    " />
                </div>
                <div class="text vanwee3">
                  <p v-html="populariTitleItem[1]"></p>
                  <span v-html="
                      this.$store.state.serverImages.homePopularScienceText
                    "></span>
                  <div @click="
                      resourcesClick(
                        '/popularScience/index/PopularScience5',
                        'PopularScience5'
                      )
                    ">
                    查看更多
                    <svg-icon class-name="search-icon" icon-class="右箭头" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h1 @click="
                resourcesClick(
                  '/popularScience/journalismIndex/PopularScience7',
                  'PopularScience7'
                )
              ">
              通知通告
            </h1>
            <p>inform annunciate</p>
            <div class="content_box">
              <a @click="imgclickHander(item, 2)" :key="index" v-for="(item, index) in informData">
                <div class="content_text">
                  <div>
                    <div>
                      {{ item.title }}
                    </div>
                    <div>
                      {{ item.content }}
                    </div>
                  </div>
                </div>
                <div class="content_time">
                  <div>
                    <div>
                      {{ item.date }}
                    </div>
                    <div>
                      {{ item.year }}
                    </div>
                  </div>
                  <div>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </a>
            </div>
            <div class="content_more" @click="
                resourcesClick(
                  '/popularScience/journalismIndex/PopularScience7',
                  'PopularScience7'
                )
              ">
              <span>查看更多</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="blogroll">
      <span>友情链接：</span>
      <a :href="item.url" v-for="(item, index) in blogrollata" target="_blank" :key="index">{{ item.urlName }}</a>
    </div>

   <div class="up_top" href="#">
        <!-- <div class="call" v-if="yz">
        <img :src="callSrc" alt="手机app" title="手机app" @mouseenter="chcallSrc('b')" @mouseleave="chcallSrc('a')" />
        <div class="call_show" v-if="callShow">
          <img :src="this.$store.state.serverImages.appImages">
        </div>
      </div>

      <div class="follow" v-if="this.$store.state.needWeChatCode">
        <img :src="followSrc" alt="微信公众号" title="微信公众号" @mouseenter="chfollowSrc('b')" @mouseleave="chfollowSrc('a')" />
        <div class="code" v-if="followShow">
          <img :src="this.$store.state.serverImages.wxImages" />
        </div>
      </div> -->
      <div class="up" @click.prevent="animateHander()">
        <img @mouseenter="changeImageSrc('d')" @mouseleave="changeImageSrc('l')" :src="upTopSrc" alt="回到顶部" title="回到顶部" />
      </div>

    </div>

    <!-- <Code></Code> -->
    <Footer></Footer>
  </div>
</template>

<script>
import $ from "jquery";
import { Swiper, swiperSlide } from "vue-awesome-swiper";
import HeaderA from "@/components/public/headerA";
// import Code from '@/components/public/code'
import Footer from "@/components/public/footer";
export default {
  data () {
    return {
      blogrollata: [],
      noticeData: [],
      wetlandSceneryData1: [],
      wetlandSceneryData2: [],
      resourcesImageData: [],
      resourcesTitleData: [],
      resourcesBtnLink: "",
      travelImageData: [],
      travelTitleData: [],
      travelBtn: "",
      travelchoose: null,
      animalImageData: [],
      animalTitleData: [],
      animalBtn: "",
      animalchoose: null,
      plantImageData: [],
      plantTitleData: [],
      plantBtn: "",
      plantchoose: null,
      yz:false,
      populari_title: null,
      populari_content: null,
      populariTitleItem: ["湿地课堂", "湿地宣教"],
      populariDescItem: [
        "湿地是位于陆生生态系统和水生生态系统之间的过渡性地带，在土壤浸泡于水中的特定环境下，生长着很多湿地的特征水生植物。湿地广泛分布于世界各地，拥有众多野生动植物资源，是重要的生态系统。很多珍惜水禽的繁殖和迁徙离不开湿地，因此湿地被称为“鸟类的乐园”。同时，湿地具有强大的生态净化能力，因而又有“地球之肾”的美名。目前世界上最大的湿地包括亚马逊盆地和西西伯利亚平原。另一个大湿地是潘塔纳尔湿地，横跨南美洲的巴西、玻利维亚和巴拉圭。",
        "湿地保护是环境保护的重要领域，它与所有生活在地球上的人都有着极为密切的关系，失去湿地，人类将无法生存。1971年2月2日，苏联、英国和加拿大等18个国家的代表在伊朗的拉姆萨尔签署了《关于特别是作为水禽栖息地的国际重要湿地公约》（简称《湿地公约》），从此，湿地保护成为了全球性政府间协调一致的国际行动。这个公约的主要作用是通过各国政府间的共同合作，以保护湿地及其生物多样性，特别是水禽和它赖以生存的环境。《湿地公约》在国际社会引起广泛关注，截至2017年，缔约国已发展到169个。我国于1992年加入了这一组织。"
      ],
      populari_link: "",
      informData: [],
      landscapeImg: [
        {
          img:
            "http://47.110.245.84:9010/zhsd/zhsdImages/attachFiles/T_TOURIST_RESOURCES/74be147b1a5842a3ad95294ffa2327d1.png",
          text: "111111111111111111111111111111"
        },
        {
          img:
            "http://47.110.245.84:9010/zhsd/zhsdImages/attachFiles/T_TOURIST_RESOURCES/74be147b1a5842a3ad95294ffa2327d1.png",
          text: "111111111111111111111111111111"
        }
      ],
      upTopSrc: require(`@/assets/images/zhiding_l.png`),
      followSrc: require(`@/assets/images/follow_a.png`),
      callSrc: require(`@/assets/images/call_a.png`),
      followShow: false,
      callShow: false
    };
  },
  components: {
    HeaderA,
    // Code,
    Footer,
    Swiper,
    swiperSlide
  },
  created(){
    this.fatherMethod()
  },
  methods: {
    // 判断登录
      fatherMethod(){
        if(sessionStorage.getItem("uName")){
                this.yz=true
          }else{
              this.yz=false
          }
          console.log(this.yz)
      },
    // 锚点跳转动画
    animateHander () {
      $("html, body")
        .stop()
        .animate({ scrollTop: "0" }, 800);
      return false;
    },
    changeImageSrc (key) {
      this.upTopSrc = require(`@/assets/images/zhiding_${key}.png`);
    },
    chfollowSrc (key) {
      this.followSrc = require(`@/assets/images/follow_${key}.png`);
      if (key == 'a') {
        this.followShow = false;
      } else {
        this.followShow = true;
      }
    },
    chcallSrc (key) {
      this.callSrc = require(`@/assets/images/call_${key}.png`);
      if (key == 'a') {
        this.callShow = false;
      } else {
        this.callShow = true;
      }
    },
    resourcesClick (currentRole, key) {
      this.$router.push({ path: currentRole, query: { value: key } });
    },
    // 资源切换
    // changeResources(index) {
    //   if (index === 0) {
    //     this.resourcesImageData = this.travelImageData;
    //     this.resourcesTitleData = this.travelTitleData;
    //     this.resourcesBtnLink = this.travelBtn;
    //     this.travelchoose = true;
    //     this.animalchoose = false;
    //     this.plantchoose = false;
    //   } else if (index === 1) {
    //     this.resourcesImageData = this.animalImageData;
    //     this.resourcesTitleData = this.animalTitleData;
    //     this.resourcesBtnLink = this.animalBtn;
    //     this.travelchoose = false;
    //     this.animalchoose = true;
    //     this.plantchoose = false;
    //   } else if (index === 2) {
    //     this.resourcesImageData = this.plantImageData;
    //     this.resourcesTitleData = this.plantTitleData;
    //     this.resourcesBtnLink = this.plantBtn;
    //     this.travelchoose = false;
    //     this.animalchoose = false;
    //     this.plantchoose = true;
    //   }
    // },
    // 单击进行跳转
    imgclickHander (item, type) {
      let linkType = 7;

      this.$router.push({
        path: "/popularScience/journalismIndex/PopularSciencePost",
        query: {
          value: "PopularSciencePost",
          type: linkType,
          id: item.id,
          search: ""
        }
      });
    },

    filterLabel (data) {
      if (data !== '') {
        return data.split('</p>')[0].split('>')[1]
      } else {
        return ''
      }

    },
    // 本地图片获取
    getServerimages () {
      this.axios
        .get(this.$store.state.Url10 + "pageResource/queryAllPageResource", {
          // 通过这种方式解决模糊匹配后台报空指针异常的问题
          params: {
            limit: 100,
            startPage: 1,
            soId: this.$store.state.Soid
          }
        })
        .then(data => {
          data = data.data.data;
          // 全部静态数据对象编码
          let manual = this.$store.state.manualServerImages,
            // 全部静态数据对象
            serverImages = this.$store.state.serverImages;

          for (const i in data) {
            for (const j in manual) {
              if (data[i].resourceCode == manual[j]) {
                switch (data[i].resourceType) {
                  case 0:
                    serverImages[j] = data[i].content;
                    break;
                  case 1:
                    serverImages[j] =
                   
                      (data[i].attList.length == 0
                        ? ""
                        :   this.$store.state.Url10 + data[i].attList[0].uaPath);
                    break;
                  case 2:
                    serverImages[j] =
                      (data[i].attList.length == 0
                        ? ""
                        :   this.$store.state.Url10 + data[i].attList[0].uaPath);
                    break;
                  case 3:
                    serverImages[j] = data[i].content;
                    break;
                  default:
                    break;
                }
                delete manual[j];
                break;
              }
            }
          }
          this.$store.state.serverImages = serverImages;
          // sessionStorage.setItem("serverImage", JSON.stringify(serverImages));
          // icon替换
          console.log(this.$store.state.serverImages);
          var link = document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = this.$store.state.serverImages.logoImage;
          document.getElementsByTagName("head")[0].appendChild(link);
          // 标题替换
          document.title = this.$store.state.serverImages.logoText || ''
          this.$store.state.title = this.$store.state.serverImages.logoText
          this.$store.state.videoTitle = this.$store.state.serverImages.logoText
          // 唯一标识缩写替换
          this.$store.state.projectName = this.$store.state.serverImages.abbreviation
          this.$store.state.identification = this.$store.state.serverImages.abbreviation
          // 二维码是否展示替换
          this.$store.state.needWeChatCode = this.$store.state.serverImages.wxImages == '' ? false : true
          this.$store.state.needAppCode = this.$store.state.serverImages.appImages == '' ? false : true
          // 一张图坐标替换
          if (this.$store.state.serverImages.aPictureCoordinate !== '') { this.$store.state.initExtent = this.$store.state.serverImages.aPictureCoordinate.split(",").map(Number); }


          $(".video_hide").css(
            "background-image",
            "url(" + this.$store.state.serverImages.videoImages + ")"
          );

          setTimeout(() => {
            // banner轮播图
            const banner_swiper = new Swiper(".banner_carousel", {
              loop: true, // 循环模式选项
              autoplay: {
                disableOnInteraction: false, //  用户操作swiper之后，是否要禁止autoplay。默认的状态是true，改成禁止。
                delay: 5000 //自动切换的时间
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              }
            });
          });

          this.$nextTick(function () {
            $(".popularization_content_propaganda").height(
              $(".popularization_content_propaganda .text span").height() + 110
            );
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  activated () {
    // 计算页面高度
    $(".banner_carousel").css("height", $(window).height() - 260 + "px");

    this.$nextTick(function () {
      $("#headerContainer101").addClass("active");

      $(".header_nav li").removeClass("active");
      // $(".popularization_content_classroom").height(
      //   $(".popularization_content_classroom .text span").height() + 110
      // );
      // setTimeout(() => {
      //   $(".popularization_content_propaganda").height(
      //     $(".popularization_content_propaganda .text span").height() + 110
      //   );
      // });
    });

    $(".up_top img:hover").src = require("../assets/images/zhiding_d.png");

    var window_height = document.documentElement.clientHeight - 100;
    // 用户手动修改浏览器可见区域高度时修改变量
    window.onresize = function () {
      window_height = document.documentElement.clientHeight;
    };
    // 获取所需效果元素
    var My_vanwee = document.getElementsByClassName("vanwee");
    var My_vanwee2 = document.getElementsByClassName("vanwee2");
    var My_vanwee3 = document.getElementsByClassName("vanwee3");
    // 鼠标滚轮滚动执行方法
    window.onscroll = function () {
      // 获取鼠标滚轮滚动距离
      var _scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;

      var mainH = $(".app-main").height() - $(".footer").height();

      if (_scrollTop > 500) {
        $(".up_top img").show(200);
      } else {
        $(".up_top img").hide(200);
      }
      // $(".up_top").css(
      //   "bottom",
      //   (_scrollTop + document.body.clientHeight + 30 > mainH
      //     ? _scrollTop + document.body.clientHeight - mainH + 81
      //     : 250) + "px"
      // );
      $(".up_top").css("bottom", '300px');
      if (_scrollTop + document.body.clientHeight + 30 > mainH) {
        $(".up_top").css("bottom", _scrollTop + document.body.clientHeight - mainH + 170 + 'px');
      }

      $(".up_top").css("right", '35px');
      // 循环类vanwee
      for (var k = 0; k < My_vanwee.length; k++) {
        if (
          My_vanwee[k].classList.contains("f-up") == false &&
          _scrollTop >= getOffsetTop(My_vanwee[k]) - window_height &&
          _scrollTop <= getOffsetTop(My_vanwee[k])
        ) {
          My_vanwee[k].classList.add("f-up");
        }
      }
      for (var k = 0; k < My_vanwee2.length; k++) {
        if (
          My_vanwee2[k].classList.contains("f-up") == false &&
          _scrollTop >= getOffsetTop(My_vanwee2[k]) - window_height &&
          _scrollTop <= getOffsetTop(My_vanwee2[k])
        ) {
          My_vanwee2[k].classList.add("f-up");
        }
      }
      for (var k = 0; k < My_vanwee3.length; k++) {
        if (
          My_vanwee3[k].classList.contains("f-up") == false &&
          _scrollTop >= getOffsetTop(My_vanwee3[k]) - window_height &&
          _scrollTop <= getOffsetTop(My_vanwee3[k])
        ) {
          My_vanwee3[k].classList.add("f-up");
        }
      }
    };
    // 判断元素父集是否有已定位元素
    function getOffsetTop (ele) {
      var rtn = ele.offsetTop;
      var o = ele.offsetParent;
      while (o != null) {
        rtn += o.offsetTop;
        o = o.offsetParent;
      }
      return rtn;
    }
    // 滚动条等于0时执行第一屏效果
    function my_animation () {
      var _scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      // 效果方法
      for (var k = 0; k < My_vanwee.length; k++) {
        if (
          My_vanwee[k].classList.contains("f-up") == false &&
          _scrollTop >= getOffsetTop(My_vanwee[k]) - window_height &&
          _scrollTop <= getOffsetTop(My_vanwee[k])
        ) {
          My_vanwee[k].classList.add("f-up");
        }
      }
    }
    my_animation();

    // 箭头自动移动事件
    let flag = 1;
    let top = 1;
    const timer = setInterval(() => {
      if (flag) {
        top++;
        if (top == 5) {
          flag = 0;
        }
      } else {
        top--;
        if (top == 0) {
          flag = 1;
        }
      }
      $(".content_desc>div>img").css("top", top);
    }, 100);
    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });

    // 视频播放事件
    $(".content_video video").height($(".content_video").height());
    $(".video_hide").click(() => {
      $(".video_hide").hide();
      document.getElementById("movie1").play();
    });

    this.animalBtn = "/stepInWetland/resource/2";
    this.plantBtn = "/stepInWetland/resource/3";
    this.travelBtn = "/stepInWetland/resource/1";

    // 通知通告内容渲染
    this.axios
      .get(this.$store.state.Url10 + "notice/queryNoticeByFilter", {
        // 通过这种方式解决模糊匹配后台报空指针异常的问题
        params: {
          limit: 3,
          start: 1,
          soId: this.$store.state.Soid
        }
      })
      .then(data => {
        data = data.data.data;
        this.informData = [];
        for (let i in data) {
          let year = data[i].createTime.substr(0, 4);
          let date = data[i].createTime.substr(
            data[i].createTime.length - 14,
            5
          );
          this.informData.push({
            title: data[i].title,
            content: data[i].descript,
            year: year,
            date: date,
            id: data[i].id,
            src: "/popularScience/informAnnunciate_post.html?id=" + data[i].id
          });
        }
      })
      .catch(err => {
        console.log(err);
      });

    //湿地风光数据获取
    this.axios
      .get(
        this.$store.state.Url10 + "WetlandScenery/findWetlandSceneryFilter",
        {
          // 通过这种方式解决模糊匹配后台报空指针异常的问题
          params: {
            limit: 5,
            start: 1,
            soId: this.$store.state.Soid
          }
        }
      )
      .then(res => {
        this.wetlandSceneryData1 = [];
        this.wetlandSceneryData2 = [];
        let data = res.data.data;
        for (const i in data) {
          if (i < 3) {
            this.wetlandSceneryData1.push({
              img: this.$store.state.Url10 + data[i].attList[0].uaPath,
              name: data[i].name,
              content: data[i].content
            });
          } else {
            this.wetlandSceneryData2.push({
              img: this.$store.state.Url10 + data[i].attList[0].uaPath,
              name: data[i].name,
              content: data[i].content
            });
          }
        }
      })
      .catch(err => {
        console.log(err);
      });

    //头条数据获取
    this.axios
      .get(this.$store.state.Url10 + "notice/getNoticeList", {
        // 通过这种方式解决模糊匹配后台报空指针异常的问题
        params: {
          number: 100,
          soId: this.$store.state.Soid
        }
      })
      .then(res => {
        this.noticeData = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });

    //友情链接数据获取
    this.axios
      .get(
        this.$store.state.Url10 + "FriendshipLinks/findFriendshipLinksFilter",
        {
          // 通过这种方式解决模糊匹配后台报空指针异常的问题
          params: {
            limit: 10,
            start: 1,
            soId: this.$store.state.Soid
          }
        }
      )
      .then(res => {
        this.blogrollata = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  mounted () {
    this.getServerimages();
  },
  updated () {
    $(".resources_box>div a img").css("height", "260px");
    $(".resources_container a").css("height", "260px");
    $(".resources_container a")
      .off()
      .hover(
        function () {
          $(".resources_title a")
            .eq($(this).index())
            .css("color", "#08961E");
        },
        function () {
          $(".resources_title a")
            .eq($(this).index())
            .css("color", "#181818");
        }
      );
  }
};
</script>

<style scoped="scoped" lang="scss">
.call > img {
  position: relative;
  width: 66px !important;
  left: -9px;
  top: 3px;
}
.up_top {
  width: 50px;
  position: fixed;
  /*background: #d4d0d0;*/
  /*padding: 20px 10px;*/
  & img {
    width: 100%;
  }
  & .follow,
  & .call {
    position: relative;
  }
  & .code,
  & .call_show {
    position: absolute;
    top: -40px;
    right: 70px;
    width: 150px;
  }
}
.index {
  // padding-top: 100px;
}
.banner_carousel img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner_carousel {
  position: relative;
  .headline {
    width: calc(60% - 50px);
    height: 50px;
    margin: 0 20%;
    line-height: 50px;
    background-color: #1e1c1c8f;
    position: absolute;
    bottom: 0;
    z-index: 9;
    color: white;
    padding: 0 25px;

    .headline_logo {
      font-size: 28px;
      float: left;

      &:after {
        width: 2px;
        height: 28px;
        content: "";
        background: rgba(228, 228, 228, 1);
        display: inline-block;
        margin: 0 20px;
        position: relative;
        top: 4px;
      }
    }

    .headline_title {
      width: calc(100% - 100px);
      height: 100%;
      margin: 0 auto;
      position: relative;

      p {
        display: inline-block;
        font-size: 17px;
        width: calc(100% - 60px);
        height: 100%;
      }

      marquee {
        cursor: pointer;
        display: inline-block;
        text-align: initial;
        white-space: nowrap;
        height: 30px;
        line-height: 30px;
        transform: translateY(10px);

        a {
          color: white;
          margin-right: 80px;

          &:hover {
            color: rgb(235, 102, 14);
          }
        }
      }
    }
  }
}
.content {
  padding: 20px 0 0 0;
  text-align: center;
  background-image: url("../assets/images/首页bgi.png");
}
.content_desc {
  background-image: url("../assets/images/首页desc.png");
  background-size: 100% 100%;
  height: 500px;
  background-repeat: no-repeat;
  padding: 20px 20% 0 20%;
}
.content h1 {
  color: #08961e;
  cursor: pointer;
}
.content h1 a {
  color: #08961e;
}
.content p:nth-child(2) {
  display: inline-block;
  width: 30%;
  color: #08961e;
  font-family: arial;
  font-size: 12px;
  margin-top: 5px;
}
.content_desc > p:nth-child(3) {
  margin-top: 30px;
  line-height: 24px;
  color: #666666;
  font-size: 14px;
}
/* .content_desc > div {
  margin-top: 30px;
  height: 65px;
  position: relative;
} */
.content_desc > div img {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.content_scenery {
  margin-bottom: 50px;
  padding: 0px 20% 0 20%;
}
.content_video {
  margin-top: 30px;
  position: relative;
  width: 52%;
  height: 320px;
}

.intro {
  position: relative;

  .content_video {
    left: 0;
    position: absolute;
    margin-top: 30px;
    // animation: wrapper-gradient 1s 1 ease-in-out;
    visibility: hidden;
  }

  .f-up {
    animation-name: f-up; /*动画名称*/
    animation-duration: 0.8s; /*动画持续时间*/
    animation-iteration-count: 1; /*动画次数*/
    animation-delay: 0s; /*延迟时间*/
    visibility: visible;
  }

  .video_intro {
    width: 52%;
    right: 0;
    height: 320px;
    position: absolute;
    margin-top: 60px;
    background-color: #44a9502a;
    font-size: 16px;

    span {
      display: block;
      margin-left: 80px;
      margin-right: 30px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      line-height: 26px;
      color: #666666;
      text-align: left;
      animation: opacity1 1s 1 ease-in-out;
    }
  }
}

@keyframes opacity1 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}

@keyframes wrapper-gradient {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  50% {
    transform: translateY(50%);
    opacity: 0.8;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.video_hide {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background: no-repeat;
  background-size: 100% 100%;
}
.video_pause {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.content_video video {
  position: relative;
  z-index: 1;
  width: 100%;
  outline: none;
  background: #110104;
}
.content_resources {
  height: 380px;
  padding: 0px 20% 0 20%;
}

.landscape_img_content {
  width: 100%;
  height: 600px;
  visibility: hidden;

  div > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .landscape_intro {
    width: calc(100% - 30px);
    padding: 10px;
    position: absolute;
    bottom: 5px;
    color: white;
    background-color: #00000077;
    cursor: pointer;

    &:hover {
      span {
        animation: wrapper-gradient 0.5s 1 linear;
        display: block;
      }
    }

    p {
      width: 100%;
      text-align: left;
    }
    span {
      display: none;
      width: 100%;
      word-wrap: break-word;
      text-align: left;
    }
  }

  .landscape_img_left {
    width: 60%;
    height: 100%;
    float: left;

    & > div {
      padding: 5px;
      position: relative;
    }

    & > div:nth-child(1) {
      width: calc(50% - 10px);
      height: calc(50% - 10px);
      float: left;
    }
    & > div:nth-child(2) {
      width: calc(50% - 10px);
      height: calc(50% - 10px);
      float: left;
    }
    & > div:nth-child(3) {
      width: calc(100% - 10px);
      height: calc(50% - 10px);
      float: left;
    }
  }
  .landscape_img_right {
    width: 40%;
    height: 100%;
    float: left;

    & > div {
      padding: 5px;
      position: relative;
    }

    & > div:nth-child(1) {
      width: calc(100% - 10px);
      height: calc(65% - 10px);
    }
    & > div:nth-child(2) {
      width: calc(100% - 10px);
      height: calc(35% - 10px);
    }
  }
}

.f-up {
  animation-name: f-up; /*动画名称*/
  animation-duration: 0.8s; /*动画持续时间*/
  animation-iteration-count: 1; /*动画次数*/
  animation-delay: 0s; /*延迟时间*/
  visibility: visible;
}

@keyframes f-up {
  0% {
    will-change: transform; /*优化动画卡顿1*/
    opacity: 0; /*初始状态 透明度为0*/
    transform: translateY(100%); /*初始状态 文档流下100px*/
  }
  100% {
    opacity: 1; /*结尾状态 透明度为1*/
    transform: translateY(0%); /*初始状态 恢复正常位置*/
  }
}

@keyframes f-up2 {
  0% {
    opacity: 0; /*初始状态 透明度为0*/
  }
  100% {
    opacity: 1; /*结尾状态 透明度为1*/
  }
}

.resources_box > p {
  display: inline-block;
  width: 60%;
  overflow: hidden;
}
.resources_box > p span {
  font-size: 20px;
  width: 33.33%;
  float: left;
  color: #181818;
  cursor: pointer;
  box-sizing: border-box;
}
.resources_box > p span:first-child {
  padding-right: 3%;
}
.resources_box > p span:last-child {
  padding-left: 3%;
}

.resources_container {
  margin-top: 10px;

  .f-up {
    animation-name: f-up; /*动画名称*/
    animation-duration: 0.8s; /*动画持续时间*/
    animation-iteration-count: 1; /*动画次数*/
    animation-delay: 0s; /*延迟时间*/
    visibility: visible;
  }

  a {
    position: relative;
    visibility: hidden;

    &:before {
      width: 0%;
      height: 100%;
      background-color: rgba(8, 150, 29, 0.253);
      content: "";
      display: block;
      position: absolute;
    }
    &:hover :before {
      width: 100%;
    }

    &:hover {
      span:after {
        width: 100%;
        animation-name: border_bottom; /*动画名称*/
        animation-duration: 0.8s; /*动画持续时间*/
        animation-iteration-count: 1; /*动画次数*/
        animation-delay: 0s; /*延迟时间*/
      }

      span:before {
        width: 100%;
        height: 100%;
      }
    }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      color: white;
      font-size: 21px;

      &:after {
        width: 0%;
        height: 2px;
        background-color: #ffffff;
        content: "";
        display: block;
        margin-top: 2px;
      }
    }

    > img {
      object-fit: cover;
      width: 100%;
    }
  }
}

@keyframes border_bottom {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

.resources_container > a {
  float: left;
  width: 30%;
  margin-right: 5%;
  cursor: pointer;
  // border-radius: 50%;
  overflow: hidden;
}
.resources_container > a:last-child {
  margin-right: 0;
}
.resources_container > a img {
  // border-radius: 50%;
  transition: 0.2s linear;
}
.resources_container > a img:hover {
  transform: scale(1.1);
}
.resources_title a {
  cursor: pointer;
  color: #181818;
  width: 20%;
  display: inline-block;
  transition: 0.2s linear;
  box-sizing: border-box;
}
.resources_title span:first-child {
  padding-right: 2%;
}
.resources_title span:last-child {
  padding-left: 2%;
}
.resources_box .resources_native {
  color: #08961e;
}
.resources_box > p span:hover {
  color: #08961e;
}
.resources_box > div:nth-child(2) {
  overflow: hidden;
  margin-top: 30px;
  padding: 20px 20%;
}
.content_more {
  margin-top: 30px;
}
.content_more span {
  display: inline-block;
  padding: 5px 10px;
  border: 2px solid #17a900;
  color: #17a900;
  cursor: pointer;
  transition: 0.2s linear;
}
.content_more span:hover {
  background-color: #17a900;
  color: white;
}
.content-bottom {
  background-color: white;
  margin-bottom: 50px;
}
.popularization {
  padding: 20px 20% 0 20%;
  margin-bottom: 50px;
}
.popularization_content {
  margin-top: 30px;

  & > div {
    width: 100%;
    height: 400px;
    margin-top: 40px;
    box-shadow: 0px 1px 10px 0px #e3e1e1;

    & > div {
      width: 50%;
      height: 100%;
      float: left;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    visibility: hidden;
  }

  .img {
    .f-up {
      animation-name: f-up; /*动画名称*/
      animation-duration: 0.8s; /*动画持续时间*/
      animation-iteration-count: 1; /*动画次数*/
      animation-delay: 0s; /*延迟时间*/
      visibility: visible;
    }
  }

  .text {
    width: calc(50% - 60px);
    margin: 0 30px;
    position: relative;
    line-height: 26px;
    text-align: left;
    opacity: 0;
    animation: opacity1 1s 1 ease-in-out;

    p {
      color: #333333;
      font-size: 20px;
      margin: 10px 0;
      font-weight: 550;
    }

    span {
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }

    div {
      width: 120px;
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      text-align: center;
      background-color: #66bb6a;
      border-radius: 3px;
      color: white;
      cursor: pointer;
      position: absolute;
      bottom: 10px;

      a {
        color: white;
      }

      &:hover {
        background-color: #08961e;
      }
    }
  }

  .f-up {
    animation-name: f-up2; /*动画名称*/
    animation-duration: 0.8s; /*动画持续时间*/
    animation-iteration-count: 1; /*动画次数*/
    animation-delay: 0s; /*延迟时间*/
    opacity: 1;
  }
}
// .popularization_content .swiper-container {
//   height: 500px;
// }
// .popularization_content img {
//   width: 100%;
//   height: 100%;
// }
// .popularization_content .swiper-pagination {
//   text-align: right;
//   padding-right: 15px;
//   box-sizing: border-box;
// }
// .popularization_content > div:nth-child(2) {
//   padding: 0 30px 30px 30px;
//   text-align: left;
//   line-height: 30px;
//   cursor: pointer;
// }
// .popularization_content h1 a {
//   display: block;
//   letter-spacing: 5px;
//   color: white;
//   margin: 20px 0;
//   text-align: center;
// }
// .popularization_content > div:nth-child(2) > div {
//   text-indent: 40px;
// }
.popularization_desc a {
  color: rgba(255, 255, 255, 0.8);
}
.content_box {
  padding: 0 20%;
}
.content_box > a {
  display: block;
  overflow: hidden;
  background: #f7f7f7;
  transition: 0.2s linear;
  cursor: pointer;
  margin-top: 30px;
}
.content_box > a:hover {
  background: #08961e;
}
.content_box > a:hover .content_text > div > div:first-child,
.content_box > a:hover .content_text > div > div:nth-child(2),
.content_box > a:hover .content_time > div > div:first-child,
.content_box > a:hover .content_time > div:first-child,
.content_box > a:hover .content_time > div:nth-child(2) i {
  color: white;
}
.content_box > a:hover .content_text > div {
  border-right-color: white;
}
.content_box > a > div {
  float: left;
  display: inline-block;
  color: white;
}
.content_text {
  width: 80%;
  padding: 10px 0 15px 0;
}
.content_time {
  width: 20%;
  padding: 10px 0 15px 0;
  overflow: hidden;
}
.content_text > div {
  border-right: 1px solid #cacaca;
  box-sizing: border-box;
  text-align: left;
  padding: 0 15px;
  color: #989898;
}
.content_text > div > div:first-child,
.content_text > div > div:nth-child(2) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.content_text > div > div:first-child {
  font-weight: bold;
  color: #181818;
}
.content_text > div > div:nth-child(2) {
  margin-top: 10px;
  font-size: 14px;
}
.content_time > div {
  float: left;
  display: inline-block;
}
.content_time > div:first-child {
  color: #cacaca;
  width: 80%;
}
.content_time > div > div:first-child {
  font-size: 20px;
  box-sizing: border-box;
  padding-left: 15px;
}
.content_time > div:nth-child(2) {
  width: 20%;
}
.content_time > div:nth-child(2) i {
  color: #cacaca;
  font-size: 30px;
  height: 50px;
  line-height: 50px;
}

.content_more {
  margin-top: 30px;
}

.blogroll {
  width: 60%;
  height: 70px;
  padding: 0 20%;
  background-color: #f3f7f5;
  line-height: 70px;
  position: relative;
  span {
    color: #333333;
    font-size: 21px;
    font-weight: 550;
  }
  a {
    margin-right: 30px;
    margin-left: 10px;
    color: #333333;
    font-size: 18px;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media only screen and (max-width: 1500px) {
  .content_desc {
    padding: 20px 10% 0 10%;
  }

  .content_scenery {
    padding: 0px 10% 0 10%;
  }

  .up_top {
    right: calc(10% - 80px);
  }

  .content_resources {
    padding: 0px 10% 0 10%;
  }

  .popularization {
    padding: 20px 10% 0 10%;
  }

  .content_box {
    padding: 0 10%;
  }

  .blogroll {
    width: 80%;
    padding: 0 10%;
  }
  .banner_carousel {
    .headline {
      margin: 0 10%;
      width: calc(80% - 50px);
    }
  }
}
</style>

<style>
.index .swiper-pagination-bullet {
  background: white;
  opacity: 1;
  outline: none;
}
.index .swiper-pagination-bullet-active {
  width: 30px;
  border-radius: 8px;
}
.swiper-button-prev,
.swiper-button-next {
  top: 58%;
  width: 62px;
  height: 53px;
  background-size: 75px 88px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue